<template>
  <div v-if="fetchedUser">
    <h2>Edit Employee</h2>
    <div class="description">Reset Password of CanEd Employee</div>

    <v-form direction="horizontal" :model="form" :rules="rules" ref="formRef">
      <v-form-item label="Password" :label-col="{span: 6}" :wrapper-col="{span: 14}" prop="password">
        <v-input size="large" v-model="form.password" placeholder="Password"></v-input>
      </v-form-item>
      <v-form-item :wrapper-col="{offset:6, span: 14 }">
        <v-button type="primary" style="margin-right:10px" @click.prevent="submitForm('formRef')">Submit</v-button>
      </v-form-item>
    </v-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'EmpResetPassword',
  data () {
    return {
      form: {
        password: null
      },
      rules: {
        password: [{
          required: true,
          message: '* Required'
        }]
      }
    }
  },
  computed: {
    ...mapGetters([
      'fetchedUser'
    ])
  },
  watch: {
    fetchedUser: {
      handler (val) {
        if (!val) {
          this.$store.dispatch('getUserFetched', this.$route.params.id)
        } else {
          this.form = {...val}
        }
      },
      immediate: true
    }
  },
  methods: {
    selectChange (key, val) {
      this.form[key] = val
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$store.dispatch('updateUserPassword', {id: this.fetchedUser.uid, payload: this.form})
          this.$refs[formName].resetFields()
        } else {
          return false
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style scoped>
h2 {
  margin-bottom: 8px;
}
.description {
  margin-bottom: 34px;
}
</style>



// WEBPACK FOOTER //
// src/views/Admin/Employees/EmpResetPassword.vue